import { Link } from '@klubovna/api-client';
import { LinksQueryParams } from '@adminServices';

export interface LinksState {
  links: Link[];
  loading: boolean;
  error: string | null;
  params: LinksQueryParams;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const initialLinksState: LinksState = {
  links: [],
  loading: false,
  error: null,
  params: {
    page: 1,
    limit: 20,
    sortBy: 'sortOrder',
    sortOrder: 'ASC',
  },
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};
